import { UserActivityStatus } from '../enums/user-activity-status.enum';

const USER_ACTIVITY_STATUS_KEYS: Record<UserActivityStatus, string> = {
  [UserActivityStatus.NotConfirmed]: 'notConfirmed',
  [UserActivityStatus.ConfirmedOnBoard]: 'confirmedOnBoard',
  [UserActivityStatus.SignedOff]: 'signedOff',
};

export function getUserActivityStatusKey(status: UserActivityStatus): string {
  return USER_ACTIVITY_STATUS_KEYS[status] ?? '';
}
